<template>
  <div>
    <!-- <sidebar> -->
    <div class="sidebar" id="sidebar">
      <div class="sidebar-inner" id="style-15">
        <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-x="scrollHanle">
          <div id="sidebar-menu" class="sidebar-menu">
            <ul>
              <li :class="{'active': currentpage === '/index'}">
                <router-link to="/index" class="contacts">
                  <i class="la la-dashboard"></i>
                  <span>Beranda</span>
                </router-link>
              </li>
              <li :class="{'active': currentpage === '/message_report/broadcast'}">
                <router-link to="/message_report/broadcast" class="contacts">
                  <i class="la la-bullhorn"></i>
                  <span>Broadcast</span>
                </router-link>
              </li>
              <li class="submenu">
                <a>
                  <i class="la la-sitemap"></i>
                  <span>Affiliate Program</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul>
                  <li>
                    <router-link to="/referral/link" class="referral">Promotional Material</router-link>
                  </li>
                  <li>
                    <router-link to="/referral/commission" class="commission">Commission</router-link>
                  </li>
                  <li>
                    <router-link to="/referral/faq" class="commission">Faq</router-link>
                  </li>
                </ul>
              </li>

              <li class="menu-title" v-show="isOwner==true">
                <span>Membership</span>
              </li>
              <!-- <li class="submenu" v-show="isOwner==true">
                <a href="#">
                  <i class="fa fa-whatsapp"></i>
                  <span>Lisensi</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul style="display: none;">
                  <li>
                    <router-link to="/license/list" class="clients">Akun Whatsapp</router-link>
                  </li>
                  <li>
                    <router-link to="/license/summary" class="clients">Statistik</router-link>
                  </li>
                </ul>
              </li> -->
              <li class="submenu" v-show="isOwner==true">
                <a href="#">
                  <i class="la la-shopping-cart"></i>
                  <span>Transaksi</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul style="display: none;">
                  <li class>
                    <router-link to="/order/active_voucher" class="employees">Lunas</router-link>
                  </li>
                  <li>
                    <router-link to="/order/list" class="tickets">Semua</router-link>
                  </li>
                </ul>
              </li>
              <li class="submenu" v-show="isOwner==true">
                <a href="#">
                  <i class="la la-envelope"></i>
                  <span>Messages Report</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul style="display: none;">
                  <li>
                    <router-link to="/message_report/outbox" class="employees">Outbox</router-link>
                  </li>
                  <li>
                    <router-link to="/message_report/reply_buttons" class="tickets">Reply Buttons</router-link>
                  </li>
                  <li>
                    <router-link to="/message_report/smart_reply" class="tickets">Smart Auto Reply</router-link>
                  </li>
                  <li>
                    <router-link to="/license/summary" class="clients">Statistik</router-link>
                  </li>
                </ul>
              </li>
              <li class="submenu" v-show="isOwner==true">
                <a href="#">
                  <i class="la la-user"></i>
                  <span>Member</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul style="display: none;">
                  <li>
                    <router-link to="/member/list" class="employees">Daftar Member</router-link>
                  </li>
                  <li>
                    <router-link to="/member/active-lisence" class="employees">Lisensi Aktif</router-link>
                  </li>
                  <li>
                    <router-link to="/member/reseller" class="employees">Daftar Reseller</router-link>
                  </li>
                  <li>
                    <router-link to="/member/saldo/reseller" class="employees">Daftar Saldo Reseller</router-link>
                  </li>
                  <li>
                    <router-link to="/member/downline" class="employees">Daftar Downline</router-link>
                  </li>
                  <!-- <li>
                    <router-link to="/message_report/reply_buttons" class="tickets">Reply Buttons</router-link>
                  </li>
                  <li>
                    <router-link to="/message_report/smart_reply" class="tickets">Smart Auto Reply</router-link>
                  </li> -->
                </ul>
              </li>

              <li class="menu-title">
                <span>Pages</span>
              </li>
              <li :class="{'active': currentpage === '/faq'}">
                <router-link to="/faq" class="faq">FAQ</router-link>
              </li>
              <li>
                <a href="https://help.waajo.id" target="_blank">Help Desk</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.youtube.com/channel/UCvW5ivbvIoBCyC4tXhHbh5A"
                  class="terms"
                >Video Tutorial</a>
              </li>
              <!--  <li>
                <router-link to="/privacypolicy" class="privacypolicy">Privacy Policy</router-link>
              </li>-->
            </ul>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <!-- </sidebar> -->
  </div>
</template>
  <script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { mapGetters } from "vuex";
import { hasPermissionForRoute } from "@/utils/helper";

export default {
  components: {
    vueCustomScrollbar
  },
  mounted() {
    $("#sidebar-menu a").on("click", function(e) {
      if (
        $(this)
          .parent()
          .hasClass("submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    $("#sidebar-menu ul li.submenu a.active")
      .parents("li:last")
      .children("a:first")
      .addClass("active")
      .trigger("click");
  },
  computed: {
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    },
    ...mapGetters(["agentSession", "rolesMember"]),
    isOwner() {
      if (typeof this.agentSession.is_owner == "undefined") {
        return true;
      } else {
        if (this.agentSession.is_owner == 1) {
          return true;
        } else {
          return false;
        }
      }
    },
    currentpage() {
      console.log("this.$route", this.$route);
      return this.$route.path;
    }
  },
  data() {
    return {
      settings: {
        suppressScrollX: false
      },
      activeClass: "active"
    };
    //  isactive : true
  },
  methods: {
    hasPermissionForRoute(roles, route) {
      return hasPermissionForRoute(roles, route);
    },
    scrollHanle(evt) {
      console.log(evt);
    }
  }
};
</script>
          <style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
/* .ps__rail-y {
        top: 0px !important;
    height: 657px !important;
    right: -3px !important;
    background-color: transparent !important;
        } */
</style>


// WEBPACK FOOTER //
// src/components/layouts/Sidebar.vue